const chats = (state = null, action) => {
  const { payload, type } = action;

  let exists;
  switch (type) {
    case 'INITIAL_DATA':
      const filteredChat = payload.chats?.filter((chat) =>
        chat.users.every((u) => u.user !== null)
      );
      return filteredChat || [];

    case 'SET_CHAT':
      exists = state.find((x) => x._id === payload._id);

      if (!exists) {
        return [payload, ...state];
      }

      return state
        .map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...exists,
            ...payload
          };
        })
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

    case 'MARK_ONE_CHAT_READ':
      return state.map((x) => {
        if (x._id !== payload._id) return x;

        return {
          ...x,
          users: x.users.map((x) => {
            if (x._id === payload.userId) return x;

            return {
              ...x,
              notifCount: 0
            };
          })
        };
      });

    case 'NEW_MESSAGE':
      exists = state.find((x) => x._id === payload.chat?._id);

      if (!exists) {
        return [
          {
            ...payload.chat,
            updatedAt: payload.message.createdAt,
            messages: [payload.message]
          },
          ...state
        ];
      }

      return [
        {
          ...exists,
          ...payload.chat,
          updatedAt: payload.message.createdAt,
          messages: [
            payload.message,
            ...((exists.messages || []).filter((x) => !x._id || x._id !== payload.message._id) ||
              [])
          ],
          lastMessage: {
            ...payload.message,
            body: payload.message.file ? payload.chat?.lastMessage?.body : payload.message.body
          }
        },
        ...state.filter((x) => x._id !== payload.chat._id)
      ];

    case 'SET_CHATS':
      return payload.map((x) => ({
        ...x,
        messages: x.messages?.length ? x.messages : []
      }));

    case 'UPDATE_CHAT_SETTINGS':
      return state.map((x) => {
        if (x._id !== payload.chatId) return x;

        return {
          ...x,
          users: x.users.map((y) => {
            if (y.user._id !== payload.userId) return y;

            return {
              ...y,
              [payload.type]: payload.value
            };
          })
        };
      });

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default chats;
